import Header from '../components/Header'
import Footer from '../components/Footer'

const CookiePolicy = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <div className="bg-white">
          <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h1 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                Cookie Policy
              </h1>
              <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto">
                Last Updated: June 15, 2023
              </p>
            </div>

            <div className="prose prose-lg text-gray-500 mx-auto">
              <h2 className="text-2xl font-bold text-gray-900">1. What Are Cookies?</h2>
              <p>
                Cookies are small text files that are stored on your device when you visit our website. They help the website remember information about your visit, which can make it easier to visit the site again and make the site more useful to you.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">2. How We Use Cookies</h2>
              <p>We use cookies for the following purposes:</p>
              <table className="min-w-full divide-y divide-gray-200 mt-4">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cookie Type</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Purpose</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Duration</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  <tr>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">Essential Cookies</td>
                    <td className="px-6 py-4 text-sm text-gray-500">Enable core functionality like security and accessibility</td>
                    <td className="px-6 py-4 text-sm text-gray-500">Session</td>
                  </tr>
                  <tr>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">Performance Cookies</td>
                    <td className="px-6 py-4 text-sm text-gray-500">Help us understand how visitors interact with our site</td>
                    <td className="px-6 py-4 text-sm text-gray-500">1 year</td>
                  </tr>
                  <tr>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">Functional Cookies</td>
                    <td className="px-6 py-4 text-sm text-gray-500">Remember your preferences and settings</td>
                    <td className="px-6 py-4 text-sm text-gray-500">1 month</td>
                  </tr>
                  <tr>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">Targeting Cookies</td>
                    <td className="px-6 py-4 text-sm text-gray-500">Used by advertising partners to deliver relevant ads</td>
                    <td className="px-6 py-4 text-sm text-gray-500">6 months</td>
                  </tr>
                </tbody>
              </table>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">3. Third-Party Cookies</h2>
              <p>
                We use some third-party services that may set cookies, including:
              </p>
              <ul className="list-disc pl-6 mt-4">
                <li><strong>Google Analytics:</strong> For website traffic analysis</li>
                <li><strong>Facebook Pixel:</strong> For advertising effectiveness measurement</li>
                <li><strong>Hotjar:</strong> For user experience research</li>
                <li><strong>LinkedIn Insight Tag:</strong> For tracking conversions</li>
              </ul>
              <p className="mt-4">
                These third-party services have their own privacy policies which we recommend you review.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">4. Managing Cookies</h2>
              <p>
                You can control and/or delete cookies as you wish:
              </p>
              <ul className="list-disc pl-6 mt-4">
                <li>Through our cookie consent banner when you first visit our site</li>
                <li>By adjusting your browser settings (see links below for popular browsers):
                  <ul className="list-circle pl-6 mt-2">
                    <li><a href="https://support.google.com/chrome/answer/95647" className="text-primary hover:underline">Google Chrome</a></li>
                    <li><a href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences" className="text-primary hover:underline">Mozilla Firefox</a></li>
                    <li><a href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac" className="text-primary hover:underline">Safari</a></li>
                    <li><a href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" className="text-primary hover:underline">Microsoft Edge</a></li>
                  </ul>
                </li>
                <li>By using privacy tools like Ghostery or AdBlock</li>
              </ul>
              <p className="mt-4">
                Note that disabling cookies may affect your experience on our website and some features may not work properly.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">5. Your Consent</h2>
              <p>
                When you first visit our website, we will ask for your consent to use cookies. You can withdraw your consent at any time by adjusting your cookie settings or clearing your browser cookies.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">6. Changes to This Policy</h2>
              <p>
                We may update this Cookie Policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last Updated" date.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-12">7. Contact Us</h2>
              <p>
                If you have any questions about our use of cookies, please contact us at:
              </p>
              <address className="not-italic mt-2">
                TheMarketingFeeds.com<br />
                Attn: Data Protection Officer<br />
                123 Marketing Street<br />
                New York, NY 10001<br />
                Email: hello@themarketingfeeds.com<br />
                Phone: (555) 123-4567
              </address>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default CookiePolicy